import { AttributeOptions, FNOL_RequestForm } from '@dispatch/shared/types';
import { SubSection } from '@dispatch/web/ui';
import {
  Control,
  FieldValues,
  useFieldArray,
  UseFormGetValues,
  UseFormWatch,
} from 'react-hook-form';
import { FNOLClaimAttributesAdd } from './FNOLClaimAttributesAdd';
import { Divider } from '@mui/material';
import { FNOLClaimAttributesForm } from './FNOLClaimAttributesForm';

export type FNOLClaimAttributesSectionProps = {
  control: Control<FieldValues>;
  watch: UseFormWatch<FNOL_RequestForm>;
  getValues: UseFormGetValues<FNOL_RequestForm>;
  companyAttributes: AttributeOptions[];
};

export function FNOLClaimAttributesSection({
  control,
  watch,
  getValues,
  companyAttributes,
}: FNOLClaimAttributesSectionProps) {
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'claimAttributes',
  });

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <SubSection title={'Claim Attributes'}>
        <>
          <FNOLClaimAttributesAdd
            append={append}
            control={control}
            watch={watch}
            companyAttributes={companyAttributes}
          />
          <Divider />
        </>

        {fields.map((field, index) => {
          return (
            <FNOLClaimAttributesForm
              control={control}
              claimAttributeIndex={index}
              claimAttributeRemove={remove}
              field={field}
              getValues={getValues}
              companyAttributes={companyAttributes}
            />
          );
        })}
      </SubSection>
    </div>
  );
}
